// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/stem-maker-kit/stem-mk.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/stem-maker-kit/STEM-Maker-Kit-mob-banner.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Top Banner  */
.smk-top-banner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  height: 27.1vw;
}

/* Step in the world of science */
.smk-subhead p {
  color: var(--dBlue);
  font-size: 25px;
  margin-bottom: 0px;
}

.smk-pointers-wrapper {
  padding: 0 10%;
}

.smk-pointers-wrapper li {
  padding-bottom: 20px;
  text-align: justify;
}

/* Icons */
.smk-icons-wrapper {
  background-color: #f5f6fb;
}

/* Fun & creation  */
.fun-creation-container {
  padding: 0 10%;
}
.fun-creation-row {
  padding-top: 50px;
}
.fc-imgs-wrapper,
.fc-build-icons-wrapper,
.fc-imagine-icons-wrapper {
  background-color: #f1eff0;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 5px 40px;
}

.fc-txt {
  background-color: #0db6fc;
  transform: rotate(270deg);
  width: 580px;
  position: absolute;
  top: 46%;
  left: -210px;
}

.fc-txt p {
  margin-bottom: 0px;
  font-size: 25px;
  color: #fff;
  font-weight: 600;
  padding: 5px 0px;
}

.fc-green-arrow img,
.fc-red-arrow img {
  height: 100px;
  width: auto;
}

.fc-green-arrow,
.fc-red-arrow {
  padding-left: 30%;
}

.fc-col-text p {
  color: #e65c69;
  font-weight: 500;
  margin-bottom: 0px;
}

.fcb-icons-c img,
.fc-imagine-icon-a img {
  height: 120px;
  width: auto;
}

.fc-imagine-icon img {
  height: 90px;
  width: auto;
  border: 2px solid #fff;
}

.fc-imagine-icon-b img {
  height: 40px;
  width: auto;
}

/* Child learn  */
.smk-child-learn {
  background-color: #f5f6fb;
}
.smk-ch-head h2 {
  margin-bottom: 10px;
}
.smk-ch-subhead p {
  color: #000;
  font-size: 25px;
  text-transform: uppercase;
  margin-bottom: 0px;
}

.smk-ch-subhead p span {
  font-size: 40px;
}

.skm-stem-s {
  color: #f12048;
}

.skm-stem-t {
  color: #48ace6;
}

.skm-stem-e {
  color: #d6df25;
}

.skm-stem-m {
  color: #fc801b;
}

.smk-cl-img img {
  height: auto;
  width: 90%;
}

/* special about blocks */
.special-abt-blocks-container {
  padding: 0 10%;
}

.whts-special-abt-blocks {
  background-color: var(--dBlue);
  border-radius: 25px;
  padding: 5px 10px;
  text-align: center;
}

.whts-special-abt-blocks p {
  color: #fff;
  margin-bottom: 0px;
}

.special-abt-block {
  padding: 10px 40px 0px 20px;
}

.ans-special-abt-blocks {
  padding: 30px 50px;
}

.ans-special-abt-blocks p {
  text-align: justify;
}

.sab-right-line::after {
  content: "";
  position: absolute;
  background-color: #000;
  width: 2px;
  height: 70%;
  bottom: 15px;
  left: 49%;
}

/* certified: toy safety */
.toy-safety-wrapper {
  background-color: #eeeeee;
  padding: 10px 20px;
  border-radius: 50px;
}

.toy-safety-wrapper p {
  margin-bottom: 0px;
  color: var(--dBlue);
  font-weight: 500;
}

.toy-safety-wrapper p span {
  color: var(--dPink);
}

.toy-safety-col {
  padding: 20px 50px 0 50px;
}

.smk-icon-wrapper img {
  width: 250px;
  height: auto;
}

/* images  */
.smk-img-container {
  padding: 0% 10%;
}
.smk-img img {
  height: auto;
  width: 100%;
}

.smk-img-wrapper-br {
  border-right: 1px solid black;
}

/* STEM Maker Kit inclusions */
.smk-inclusions-conatiner {
  padding: 0 10%;
}

.smk-inclusions-row-bg {
  background-color: #f5f6fb;
}

.smk-inclusion-img {
  margin: 20px 0px;
}

.smk-inclusion-img img {
  height: 80px;
  width: auto;
}

.smk-inclusion-img-a {
  text-align: end;
  padding-right: 20px;
  border-right: 1px solid black;
}

.smk-inclusion-img-b {
  border-right: 1px solid black;
  text-align: center;
}

@media (max-width: 1024px) {
  .smk-icon-wrapper {
    text-align: center !important;
  }

  .siw-last {
    text-align: center !important;
  }

  .fc-green-arrow img,
  .fc-red-arrow img {
    height: 70px;
  }

  .fcb-icons-c img,
  .fc-imagine-icon-a img {
    height: 75px;
    width: auto;
  }

  .fc-imagine-icon-b img {
    height: 30px;
  }

  .fc-imagine-icon img {
    height: 75px;
  }

  .fc-txt {
    height: 50px;
    width: 440px;
    left: -40%;
    bottom: -246px;
    top: auto;
    top: initial;
  }

  .sab-right-line::after {
    content: normal;
    content: initial;
  }

  .smk-img-wrapper-br {
    border-right: 0;
    border-right: initial;
  }

  .smk-inclusion-img img {
    height: 50px;
    width: auto;
  }
}

@media (max-width: 576px) {
  .smk-top-banner {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 127.2vw;
  }

  .fun-creation-row {
    padding-top: 20px;
  }

  .fc-img img {
    height: 30px;
    width: auto;
  }

  .fc-imgs-wrapper {
    padding: 15px !important;
  }

  .fc-img-a img {
    height: 15px;
  }

  .fc-txt {
    width: 270px;
    left: -140px;
    bottom: -154px;
    top: auto;
    top: initial;
  }

  .fc-txt p {
    font-size: 18px;
  }

  .fc-imgs-wrapper,
  .fc-build-icons-wrapper,
  .fc-imagine-icons-wrapper {
    padding: 5px 15px;
  }

  .fcb-icons-c img,
  .fc-imagine-icon-a img {
    height: 45px;
  }

  .fc-imagine-icon-b img {
    height: 15px;
  }

  .fc-imagine-icon img {
    height: 30px;
  }

  .fc-green-arrow img,
  .fc-red-arrow img {
    height: 50px;
  }

  .fc-col-text p {
    font-size: 12px;
    line-height: 1;
  }

  .ans-special-abt-blocks {
    padding: 30px 20px;
  }

  .special-abt-block {
    padding: 0;
    padding: initial;
  }

  .sab-right-line::after {
    content: normal;
    content: initial;
  }

  .toy-safety-col {
    padding: 0;
    padding: initial;
  }

  .smk-icon-wrapper {
    text-align: center !important;
  }

  .smk-pointers-wrapper li {
    padding-bottom: 10px;
  }

  .smk-img {
    text-align: center;
  }

  .smk-img img {
    height: 120px;
    width: auto;
  }

  .smk-img-wrapper-br {
    border-right: 0;
    border-right: initial;
  }

  .smk-inclusion-img {
    text-align: center;
    border-right: 0;
    border-right: initial;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/indivdual-product-pages/STEM Maker Kit/STEMMakerKit.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,yDAA6E;EAC7E,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;;;EAGE,yBAAyB;EACzB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,8BAA8B;AAC9B;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;IAEE,YAAY;EACd;;EAEA;;IAEE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,cAAc;IACd,SAAU;IAAV,YAAU;EACZ;;EAEA;IACE,eAAc;IAAd,gBAAc;EAChB;;EAEA;IACE,eAAmB;IAAnB,qBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;IACE,yDAA+F;IAC/F,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,SAAU;IAAV,YAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,iBAAiB;EACnB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAc;IAAd,gBAAc;EAChB;;EAEA;IACE,eAAc;IAAd,gBAAc;EAChB;;EAEA;IACE,UAAc;IAAd,gBAAc;EAChB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,eAAmB;IAAnB,qBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAmB;IAAnB,qBAAmB;EACrB;AACF","sourcesContent":["/* Top Banner  */\n.smk-top-banner {\n  background-image: url(\"../../../../public/images/stem-maker-kit/stem-mk.png\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  height: 27.1vw;\n}\n\n/* Step in the world of science */\n.smk-subhead p {\n  color: var(--dBlue);\n  font-size: 25px;\n  margin-bottom: 0px;\n}\n\n.smk-pointers-wrapper {\n  padding: 0 10%;\n}\n\n.smk-pointers-wrapper li {\n  padding-bottom: 20px;\n  text-align: justify;\n}\n\n/* Icons */\n.smk-icons-wrapper {\n  background-color: #f5f6fb;\n}\n\n/* Fun & creation  */\n.fun-creation-container {\n  padding: 0 10%;\n}\n.fun-creation-row {\n  padding-top: 50px;\n}\n.fc-imgs-wrapper,\n.fc-build-icons-wrapper,\n.fc-imagine-icons-wrapper {\n  background-color: #f1eff0;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  padding: 5px 40px;\n}\n\n.fc-txt {\n  background-color: #0db6fc;\n  transform: rotate(270deg);\n  width: 580px;\n  position: absolute;\n  top: 46%;\n  left: -210px;\n}\n\n.fc-txt p {\n  margin-bottom: 0px;\n  font-size: 25px;\n  color: #fff;\n  font-weight: 600;\n  padding: 5px 0px;\n}\n\n.fc-green-arrow img,\n.fc-red-arrow img {\n  height: 100px;\n  width: auto;\n}\n\n.fc-green-arrow,\n.fc-red-arrow {\n  padding-left: 30%;\n}\n\n.fc-col-text p {\n  color: #e65c69;\n  font-weight: 500;\n  margin-bottom: 0px;\n}\n\n.fcb-icons-c img,\n.fc-imagine-icon-a img {\n  height: 120px;\n  width: auto;\n}\n\n.fc-imagine-icon img {\n  height: 90px;\n  width: auto;\n  border: 2px solid #fff;\n}\n\n.fc-imagine-icon-b img {\n  height: 40px;\n  width: auto;\n}\n\n/* Child learn  */\n.smk-child-learn {\n  background-color: #f5f6fb;\n}\n.smk-ch-head h2 {\n  margin-bottom: 10px;\n}\n.smk-ch-subhead p {\n  color: #000;\n  font-size: 25px;\n  text-transform: uppercase;\n  margin-bottom: 0px;\n}\n\n.smk-ch-subhead p span {\n  font-size: 40px;\n}\n\n.skm-stem-s {\n  color: #f12048;\n}\n\n.skm-stem-t {\n  color: #48ace6;\n}\n\n.skm-stem-e {\n  color: #d6df25;\n}\n\n.skm-stem-m {\n  color: #fc801b;\n}\n\n.smk-cl-img img {\n  height: auto;\n  width: 90%;\n}\n\n/* special about blocks */\n.special-abt-blocks-container {\n  padding: 0 10%;\n}\n\n.whts-special-abt-blocks {\n  background-color: var(--dBlue);\n  border-radius: 25px;\n  padding: 5px 10px;\n  text-align: center;\n}\n\n.whts-special-abt-blocks p {\n  color: #fff;\n  margin-bottom: 0px;\n}\n\n.special-abt-block {\n  padding: 10px 40px 0px 20px;\n}\n\n.ans-special-abt-blocks {\n  padding: 30px 50px;\n}\n\n.ans-special-abt-blocks p {\n  text-align: justify;\n}\n\n.sab-right-line::after {\n  content: \"\";\n  position: absolute;\n  background-color: #000;\n  width: 2px;\n  height: 70%;\n  bottom: 15px;\n  left: 49%;\n}\n\n/* certified: toy safety */\n.toy-safety-wrapper {\n  background-color: #eeeeee;\n  padding: 10px 20px;\n  border-radius: 50px;\n}\n\n.toy-safety-wrapper p {\n  margin-bottom: 0px;\n  color: var(--dBlue);\n  font-weight: 500;\n}\n\n.toy-safety-wrapper p span {\n  color: var(--dPink);\n}\n\n.toy-safety-col {\n  padding: 20px 50px 0 50px;\n}\n\n.smk-icon-wrapper img {\n  width: 250px;\n  height: auto;\n}\n\n/* images  */\n.smk-img-container {\n  padding: 0% 10%;\n}\n.smk-img img {\n  height: auto;\n  width: 100%;\n}\n\n.smk-img-wrapper-br {\n  border-right: 1px solid black;\n}\n\n/* STEM Maker Kit inclusions */\n.smk-inclusions-conatiner {\n  padding: 0 10%;\n}\n\n.smk-inclusions-row-bg {\n  background-color: #f5f6fb;\n}\n\n.smk-inclusion-img {\n  margin: 20px 0px;\n}\n\n.smk-inclusion-img img {\n  height: 80px;\n  width: auto;\n}\n\n.smk-inclusion-img-a {\n  text-align: end;\n  padding-right: 20px;\n  border-right: 1px solid black;\n}\n\n.smk-inclusion-img-b {\n  border-right: 1px solid black;\n  text-align: center;\n}\n\n@media (max-width: 1024px) {\n  .smk-icon-wrapper {\n    text-align: center !important;\n  }\n\n  .siw-last {\n    text-align: center !important;\n  }\n\n  .fc-green-arrow img,\n  .fc-red-arrow img {\n    height: 70px;\n  }\n\n  .fcb-icons-c img,\n  .fc-imagine-icon-a img {\n    height: 75px;\n    width: auto;\n  }\n\n  .fc-imagine-icon-b img {\n    height: 30px;\n  }\n\n  .fc-imagine-icon img {\n    height: 75px;\n  }\n\n  .fc-txt {\n    height: 50px;\n    width: 440px;\n    left: -40%;\n    bottom: -246px;\n    top: unset;\n  }\n\n  .sab-right-line::after {\n    content: unset;\n  }\n\n  .smk-img-wrapper-br {\n    border-right: unset;\n  }\n\n  .smk-inclusion-img img {\n    height: 50px;\n    width: auto;\n  }\n}\n\n@media (max-width: 576px) {\n  .smk-top-banner {\n    background-image: url(\"../../../../public/images/stem-maker-kit/STEM-Maker-Kit-mob-banner.jpg\");\n    height: 127.2vw;\n  }\n\n  .fun-creation-row {\n    padding-top: 20px;\n  }\n\n  .fc-img img {\n    height: 30px;\n    width: auto;\n  }\n\n  .fc-imgs-wrapper {\n    padding: 15px !important;\n  }\n\n  .fc-img-a img {\n    height: 15px;\n  }\n\n  .fc-txt {\n    width: 270px;\n    left: -140px;\n    bottom: -154px;\n    top: unset;\n  }\n\n  .fc-txt p {\n    font-size: 18px;\n  }\n\n  .fc-imgs-wrapper,\n  .fc-build-icons-wrapper,\n  .fc-imagine-icons-wrapper {\n    padding: 5px 15px;\n  }\n\n  .fcb-icons-c img,\n  .fc-imagine-icon-a img {\n    height: 45px;\n  }\n\n  .fc-imagine-icon-b img {\n    height: 15px;\n  }\n\n  .fc-imagine-icon img {\n    height: 30px;\n  }\n\n  .fc-green-arrow img,\n  .fc-red-arrow img {\n    height: 50px;\n  }\n\n  .fc-col-text p {\n    font-size: 12px;\n    line-height: 1;\n  }\n\n  .ans-special-abt-blocks {\n    padding: 30px 20px;\n  }\n\n  .special-abt-block {\n    padding: unset;\n  }\n\n  .sab-right-line::after {\n    content: unset;\n  }\n\n  .toy-safety-col {\n    padding: unset;\n  }\n\n  .smk-icon-wrapper {\n    text-align: center !important;\n  }\n\n  .smk-pointers-wrapper li {\n    padding-bottom: 10px;\n  }\n\n  .smk-img {\n    text-align: center;\n  }\n\n  .smk-img img {\n    height: 120px;\n    width: auto;\n  }\n\n  .smk-img-wrapper-br {\n    border-right: unset;\n  }\n\n  .smk-inclusion-img {\n    text-align: center;\n    border-right: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
